import { render, staticRenderFns } from "./RewardsProgramModal.vue?vue&type=template&id=b98e5ed4&scoped=true&"
import script from "./RewardsProgramModal.vue?vue&type=script&lang=ts&"
export * from "./RewardsProgramModal.vue?vue&type=script&lang=ts&"
import style0 from "./RewardsProgramModal.vue?vue&type=style&index=0&id=b98e5ed4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98e5ed4",
  null
  
)

export default component.exports